import React, { useEffect, useState } from "react";
import WebsiteNavbar from "../components/Website/WebsiteNavbar";
import Footer from "../components/Website/Footer";
import { Route, Routes, useLocation } from "react-router-dom";
import Webpage from "../pages/Website/Webpage";
import UserLayout from "./UserLayout";
import LoginPage from "../pages/Website/LoginPage";
import MyCart from "../pages/Website/MyCart";
import BottomNav from "../components/Website/BottomNav";
import SignupPage from "../pages/Website/SignupPage";
import Checkout from "../components/Website/Checkout";
import Subscriptions from "../pages/Website/UserDashboard/Subscriptions";
import OTPPage from "../pages/Website/OTPPage";
import axios from "axios";
import { apiKey } from "../config/config";
// import {useLanguage} from "../../context/LanguageContext"

export default function RootLayout() {
  const outlet = JSON.parse(localStorage.getItem("rms-outlet"));
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  const [search, setSearch] = useState(null);
  const [webSetting, setWebSetting] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [loader, setLoader] = useState(null);
  const [logo, setLogo] = useState("");
  const [showModalNav, setShowModalNav] = useState(!Boolean(outlet));
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const location = useLocation();

  const handleLangChange = (value) => {
    localStorage.setItem("rms-lang", value);
    window.location.reload();
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/settings`)
      .then((res) => {
        let colors = res.data.filter((item) => item.type === "web_color_theme");

        colors = JSON.parse(colors[0].value);

        document.documentElement.style.setProperty(
          "--color-w-bg",
          colors.color_1
        );
        document.documentElement.style.setProperty(
          "--color-w-heading",
          colors.color_2
        );
        document.documentElement.style.setProperty(
          "--color-w-btn",
          colors.color_3
        );
        document.documentElement.style.setProperty(
          "--color-w-btn-text",
          colors.color_4
        );
        document.documentElement.style.setProperty(
          "--color-w-border",
          colors.color_5
        );

        setWebSetting(
          JSON.parse(
            res.data.filter((item) => item.type === "web_settings")[0].value
          )
        );

        setLogo(
          JSON.parse(res.data.filter((item) => item.type === "logo")[0].value)
            .logo_image_url
        );

        setLoader(
          JSON.parse(res.data.filter((item) => item.type === "loader")[0].value)
        );
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        // Scrolling down
        setIsVisible(false);
      } else {
        // Scrolling up
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }
  return (
    <main dir={defaultLang === "text_en" ? "ltr" : "rtl"}>
      <header
        className={`font-rubik fixed top-0 left-0 w-full z-50 transition-transform duration-300 ${
          isVisible ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <WebsiteNavbar
          logo={logo}
          setSearch={setSearch}
          settings={webSetting}
          setShowModalNav={setShowModalNav}
          handleLangChange={handleLangChange}
        />
      </header>
      <WebsiteNavbar
        logo={logo}
        setSearch={setSearch}
        settings={webSetting}
        setShowModalNav={setShowModalNav}
        handleLangChange={handleLangChange}
      />
      <div className="font-rubik mt-4">
        <Routes>
          <Route
            path="/"
            element={
              <Webpage
                search={search}
                settings={webSetting}
                loader={loader}
                showModalNav={showModalNav}
                setShowModalNav={setShowModalNav}
              />
            }
          />
          <Route path="/login" element={<LoginPage logo={logo} />} />
          <Route path="/signup" element={<SignupPage logo={logo} />} />
          <Route path="/otp" element={<OTPPage />} />
          <Route
            path="/dashboard/*"
            element={<UserLayout logo={logo} loader={loader} />}
          />
          <Route path="/mycart" element={<MyCart />} />
          <Route path="/checkout" element={<Checkout loader={loader} />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
        </Routes>
      </div>
      <BottomNav handleLangChange={handleLangChange} />
      <Footer logo={logo} />
    </main>
  );
}
